'use client';

import { useToast } from '@common/hooks';
import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { useCustomRouter } from '@/hooks/useCustomRouter';

const ToastSearchParamsControllerComponent = () => {
  const searchParams = useSearchParams();
  const router = useCustomRouter();
  const { toast } = useToast();

  const toastMessage = searchParams?.get('toast');

  useEffect(() => {
    if (!toastMessage) return;

    toast({ message: toastMessage });

    const url = new URL(window.location.href);
    url.searchParams.delete('toast');

    router.replace(url.toString());
  }, [toastMessage, toast, router]);

  return null;
};

export const ToastSearchParamsController = () => {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <ToastSearchParamsControllerComponent />
      </Suspense>
    </ErrorBoundary>
  );
};
